import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPayEasy({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2 15.635h-.227v-.599a2.368 2.368 0 01-.365.186.751.751 0 00-.158-.188c.18-.053.351-.134.507-.24.145-.103.276-.224.39-.36l.184.143c.007.003.011.01.01.017 0 .013-.01.02-.024.02a.11.11 0 01-.027-.004c-.09.097-.187.186-.29.268v.757zM15.169 14.442c.116.037.227.088.33.152a1.609 1.609 0 00-.122.174c-.1-.069-.208-.125-.322-.165l.114-.161zM15.744 14.493c.052.04.102.082.15.127l-.1.095a1.692 1.692 0 00-.149-.134l.099-.088zM15.89 14.344c.053.038.103.08.151.125a5.396 5.396 0 01-.098.096 1.825 1.825 0 00-.15-.133l.097-.088zM15.042 14.73a2 2 0 01.31.182c-.047.055-.09.113-.13.173a1.475 1.475 0 00-.3-.18l.12-.174zM15 15.441a1.844 1.844 0 00.916-.7.429.429 0 00.134.173 1.736 1.736 0 01-.253.29 2.245 2.245 0 01-.64.42c-.003.013-.008.03-.021.03-.014 0-.02-.017-.021-.018L15 15.441z"
        fill="#000"
      />
      <path fill="#000" d="M16.412 14.951h1.144v.222h-1.144z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.812 15.063c.061-.04.115-.09.161-.146.189-.212.244-.275.287-.3a.18.18 0 01.095-.03c.085 0 .132.053.24.19.112.14.233.27.362.394.06.054.104.09.13.111a3.227 3.227 0 00-.14.192 7.328 7.328 0 01-.512-.584c-.046-.057-.066-.068-.087-.068-.032 0-.069.046-.1.08-.085.1-.165.206-.24.314a.026.026 0 01.004.018c0 .012-.01.012-.012.012a.022.022 0 01-.018-.007l-.17-.176z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.703 15.09a.5.5 0 10.923-.385.5.5 0 00-.923.385zm.228-.191a.236.236 0 11.471 0 .236.236 0 01-.47 0z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.185 18.16c-.22 0-.408-.06-.536-.172v.002a.655.655 0 01-.22-.474v-.005h1.64c.013-.388-.098-.715-.322-.95a1.16 1.16 0 00-.854-.343 1.29 1.29 0 00-.486.089 1.05 1.05 0 00-.379.247c-.107.107-.19.235-.247.375a1.288 1.288 0 00-.087.476c-.008.302.105.595.315.813.122.12.268.211.429.268.184.064.378.096.574.095.182 0 .607 0 1.016-.3v-.443c-.333.238-.553.322-.843.322zm.099-1.392a.59.59 0 01.157.371l.001.003h-.997v-.003a.594.594 0 01.152-.37.51.51 0 01.687 0zM19.218 18.426c-.166.13-.402.199-.706.199-.368 0-.726-.113-.838-.174v-.513c.255.107.486.198.757.198.15 0 .264-.03.322-.087a.113.113 0 00.04-.09c0-.14-.192-.214-.413-.297-.337-.131-.754-.293-.754-.751a.624.624 0 01.185-.452c.174-.174.452-.268.784-.268a1.6 1.6 0 01.756.17v.518c-.332-.203-.649-.26-.783-.26-.121 0-.268.033-.268.188 0 .096.158.16.357.237.341.137.812.322.812.817 0 .242-.086.433-.25.563M10.398 19.36h-.755l.545-1.192v-.004l-.887-1.903h.757l.48 1.169.002.007.006-.006.51-1.17h.745l-1.403 3.099zM20.582 19.36h-.754l.544-1.192v-.004l-.889-1.903h.759l.48 1.169.003.007.003-.006.513-1.17h.744l-1.403 3.099zM16.598 18.323c.016.079.063.15.13.195a.488.488 0 00.268.06c.195-.011.386-.062.561-.15v-.379a.305.305 0 01-.16.056.107.107 0 01-.082-.03.179.179 0 01-.04-.132v-1.04a.614.614 0 00-.17-.451c-.155-.156-.424-.236-.792-.236a1.84 1.84 0 00-.985.275v.573c.113-.114.246-.206.393-.272.139-.066.29-.101.445-.104.145 0 .252.036.321.107a.362.362 0 01.08.277v.002h-.003l-.08.025-.003.002c-.897.278-1.271.394-1.271.919.002.138.06.27.16.365a.652.652 0 00.473.192c.261 0 .486-.078.75-.259h.005v.005zm-.513-.681c.15-.09.309-.16.475-.212l.004-.002v.556a.614.614 0 01-.398.175.228.228 0 01-.165-.069.255.255 0 01-.073-.177c0-.11.05-.194.157-.271z"
        fill="#0F298F"
      />
      <path fill="#0F298F" d="M11.536 17.356h.907v.435h-.907z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.585 18.323c.015.08.061.15.129.195h-.006a.482.482 0 00.268.06c.196-.012.387-.063.563-.15v-.379a.306.306 0 01-.161.056.113.113 0 01-.084-.03.181.181 0 01-.04-.132v-1.04a.616.616 0 00-.168-.451c-.158-.156-.423-.236-.792-.236a1.847 1.847 0 00-.987.275v.575c.114-.114.248-.206.395-.272.138-.066.29-.101.443-.104.147 0 .255.036.322.108a.349.349 0 01.08.276v.002l-.078.026h-.004c-.897.28-1.27.396-1.27.92.002.138.06.27.16.365a.66.66 0 00.476.19c.26 0 .482-.078.75-.259h.004v.005zm-.52-.681c.15-.09.309-.16.475-.212l.002-.002v.556a.613.613 0 01-.398.175.222.222 0 01-.161-.069.25.25 0 01-.074-.177c0-.11.049-.194.156-.271z"
        fill="#0F298F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.633 4.553a3.302 3.302 0 00-1.46.354 4.07 4.07 0 00-1.266.982l1.385.178.006-.007c.383-.46.854-.838 1.386-1.113a3.481 3.481 0 011.588-.394H7.633z"
        fill="url(#Pay_Easy_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.168 6.125c-.216.008-.43.05-.634.123.69.429 1.145 1.29 1.145 2.298 0 1.468-.965 2.811-2.217 3.01-.11.018-.22.026-.332.024.056.074.117.145.181.213.49.506 1.15.745 1.857.614.685-.127 1.287-.579 1.708-1.198.437-.652.67-1.42.668-2.206 0-.819-.252-1.54-.668-2.057-.407-.506-.979-.82-1.631-.82h-.077"
        fill="url(#Pay_Easy_svg__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.448 13.89c.27 2.144.97 3.552 1.327 4.048l1.29.956c-.45-.701-1.159-2.264-1.402-4.537-.243-2.272-.01-5.255 1.414-8.8L4.7 5.437c-1.362 3.433-1.52 6.311-1.251 8.454z"
        fill="url(#Pay_Easy_svg__paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.684 4.947a3.481 3.481 0 011.574-.393h.014a3.16 3.16 0 011.48.366c.442.236.83.562 1.136.956.618.787.993 1.867.993 3.085a5.992 5.992 0 01-.992 3.305 4.96 4.96 0 01-1.137 1.21 3.896 3.896 0 01-1.48.697 3.218 3.218 0 01-1.963-.17 18.95 18.95 0 01-.229 1.477 20.25 20.25 0 01-.996 3.416.03.03 0 01-.008.006.01.01 0 01-.008-.006l-.02-.028-.021-.034-.01-.014c-.45-.736-1.12-2.267-1.353-4.463-.24-2.272-.01-5.255 1.413-8.799.075.166.146.34.215.509l.006-.007c.383-.46.854-.838 1.386-1.113zm-.192 4.618c0 .922.317 1.71.819 2.227v-.002c.4.414.916.65 1.477.65.127 0 .255-.013.38-.036.684-.126 1.286-.579 1.708-1.198.437-.652.67-1.42.668-2.206 0-.818-.252-1.54-.668-2.057-.42-.526-1.024-.843-1.708-.818-.707.027-1.367.415-1.857 1.03a3.889 3.889 0 00-.82 2.41z"
        fill="url(#Pay_Easy_svg__paint3_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9.345a.603.603 0 101.205 0 .603.603 0 00-1.205 0z"
        fill="url(#Pay_Easy_svg__paint4_radial)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.329 9.345a1.79 1.79 0 103.581 0 1.79 1.79 0 00-3.581 0"
        fill="url(#Pay_Easy_svg__paint5_radial)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.82 9.345a1.431 1.431 0 102.863.003 1.431 1.431 0 00-2.863-.003z"
        fill="url(#Pay_Easy_svg__paint6_radial)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91 9.345a1.145 1.145 0 102.291.001 1.145 1.145 0 00-2.29-.002"
        fill="url(#Pay_Easy_svg__paint7_radial)"
      />
      <defs>
        <radialGradient
          id="Pay_Easy_svg__paint4_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.60321 0 0 .60321 2.603 9.346)"
        >
          <stop stopColor="#CCE70B" />
          <stop offset={0.15} stopColor="#CCE70B" />
          <stop offset={0.24} stopColor="#C6E40C" />
          <stop offset={0.36} stopColor="#B6DD10" />
          <stop offset={0.5} stopColor="#9CD115" />
          <stop offset={0.64} stopColor="#77C01D" />
          <stop offset={0.79} stopColor="#48AA27" />
          <stop offset={0.95} stopColor="#0F8F34" />
          <stop offset={0.99} stopColor="#008837" />
          <stop offset={1} stopColor="#008837" />
        </radialGradient>
        <radialGradient
          id="Pay_Easy_svg__paint5_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.12 9.345) scale(1.79034)"
        >
          <stop stopColor="#CCE70B" />
          <stop offset={0.15} stopColor="#CCE70B" />
          <stop offset={0.24} stopColor="#C6E40C" />
          <stop offset={0.36} stopColor="#B6DD10" />
          <stop offset={0.5} stopColor="#9CD115" />
          <stop offset={0.64} stopColor="#77C01D" />
          <stop offset={0.79} stopColor="#48AA27" />
          <stop offset={0.95} stopColor="#0F8F34" />
          <stop offset={0.99} stopColor="#008837" />
          <stop offset={1} stopColor="#008837" />
        </radialGradient>
        <radialGradient
          id="Pay_Easy_svg__paint6_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.251 9.346) scale(1.43163)"
        >
          <stop stopColor="#CCE70B" />
          <stop offset={0.15} stopColor="#CCE70B" />
          <stop offset={0.24} stopColor="#C6E40C" />
          <stop offset={0.36} stopColor="#B6DD10" />
          <stop offset={0.5} stopColor="#9CD115" />
          <stop offset={0.64} stopColor="#77C01D" />
          <stop offset={0.79} stopColor="#48AA27" />
          <stop offset={0.95} stopColor="#0F8F34" />
          <stop offset={0.99} stopColor="#008837" />
          <stop offset={1} stopColor="#008837" />
        </radialGradient>
        <radialGradient
          id="Pay_Easy_svg__paint7_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.055 9.345) scale(1.14477)"
        >
          <stop stopColor="#CCE70B" />
          <stop offset={0.15} stopColor="#CCE70B" />
          <stop offset={0.24} stopColor="#C6E40C" />
          <stop offset={0.36} stopColor="#B6DD10" />
          <stop offset={0.5} stopColor="#9CD115" />
          <stop offset={0.64} stopColor="#77C01D" />
          <stop offset={0.79} stopColor="#48AA27" />
          <stop offset={0.95} stopColor="#0F8F34" />
          <stop offset={0.99} stopColor="#008837" />
          <stop offset={1} stopColor="#008837" />
        </radialGradient>
        <linearGradient
          id="Pay_Easy_svg__paint0_linear"
          x1={9.33}
          y1={6.085}
          x2={9.333}
          y2={4.52}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0A50A1" />
          <stop offset={0.2} stopColor="#0A50A1" />
          <stop offset={0.7} stopColor="#1D88BC" />
          <stop offset={0.74} stopColor="#258DBF" />
          <stop offset={0.81} stopColor="#3C9CC7" />
          <stop offset={0.89} stopColor="#60B4D4" />
          <stop offset={0.99} stopColor="#92D5E6" />
          <stop offset={1} stopColor="#99D9E8" />
        </linearGradient>
        <linearGradient
          id="Pay_Easy_svg__paint1_linear"
          x1={12.165}
          y1={13.294}
          x2={14.294}
          y2={7.401}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3690C0" />
          <stop offset={0.02} stopColor="#3690C0" />
          <stop offset={0.3} stopColor="#67A9CF" />
          <stop offset={0.7} stopColor="#B2D7E8" />
          <stop offset={0.78} stopColor="#7AAAD0" />
          <stop offset={0.9} stopColor="#2A6AAE" />
          <stop offset={0.95} stopColor="#0A50A1" />
          <stop offset={1} stopColor="#0A50A1" />
        </linearGradient>
        <linearGradient
          id="Pay_Easy_svg__paint2_linear"
          x1={5.516}
          y1={23.146}
          x2={10.753}
          y2={21.602}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0670B0" />
          <stop offset={0.05} stopColor="#0670B0" />
          <stop offset={0.16} stopColor="#378EC0" />
          <stop offset={0.4} stopColor="#AFD6E7" />
          <stop offset={0.72} stopColor="#5DAACF" />
          <stop offset={0.98} stopColor="#1D88BC" />
          <stop offset={1} stopColor="#1D88BC" />
        </linearGradient>
        <linearGradient
          id="Pay_Easy_svg__paint3_linear"
          x1={2.153}
          y1={12.63}
          x2={10.516}
          y2={15.965}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0290BE" />
          <stop offset={0.44} stopColor="#0859A5" />
          <stop offset={0.81} stopColor="#0D3092" />
          <stop offset={1} stopColor="#0F218B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgPayEasy
